import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isFetchingStatus: false,
  isFetchingCount: false,
  isFetchingAllCount: false,

  result: [],
};

const authFaxesReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_FAXES_REQUEST:
        return {
            ...state,
            result: [],
            isFetching: true,
        };

    case types.GET_FAXES_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetching: false,
        };

    case types.GET_FAXES_FAILURE:
        return {
            ...state,
            result: [],
            isFetching: false,
        };

    case types.GET_FAX_STATUS_REQUEST:
        return {
            ...state,
            result: [],
            isFetchingStatus: true,
        };

    case types.GET_FAX_STATUS_SUCCESS:
        return {
            ...state,
            result: action.payload,
            isFetchingStatus: false,
        };

    case types.GET_FAX_STATUS_FAILURE:
        return {
            ...state,
            result: [],
            isFetchingStatus: false,
        };

    default:
      return state;
  }
};

export default authFaxesReducer;
